// src/routes/AppRoutes.tsx
import {
  Navigate,
  Route,
  BrowserRouter as Router,
  Routes,
} from "react-router-dom";

// Páginas/Componentes
// import { Dashboard } from "@/modules/dashboard/pages";
// import { MasterReport } from "@/modules/reports/pages";
import { NavTab } from "../components/navigation";
import { ProtectedAdminRoutes } from "../components/protected-admin-routes";
import { ProtectedClientRoutes } from "../components/protected-client-routes";
import { PublicRoutes } from "../components/public-routes";
import { ChangePassword } from "../modules/account/pages/change-password";
import { Cases } from "../modules/cases/pages";
import { Clients } from "../modules/clients/pages";
import { ProfileSetup } from "../modules/dashboard/components/preparing/pages";
import { Dashboard } from "../modules/dashboard/pages";
import { EmailPage } from "../modules/email/pages";
import { FollowingProfiles } from "../modules/following-profiles/pages";
import { GoogleCallbackPageAdm } from "../modules/google-callback";
import { GoogleCallbackEmailPage } from "../modules/google-callback-email";
import { Home } from "../modules/home/pages";
import { ProfileSelection } from "../modules/login/components/select-profile";
import { Login } from "../modules/login/pages";
import { ActiveUserLogin } from "../modules/login/pages/active-user-login";
import { ForgotPassword } from "../modules/login/pages/forgot-password";
import { ResetPassword } from "../modules/login/pages/reset-password";
import PaymentError from "../modules/new-geo-ranking/components/payments/paymenterror";
import PaymentSuccess from "../modules/new-geo-ranking/components/payments/paymentsuccess";
import { GeoRanking } from "../modules/new-geo-ranking/pages";
import { Payment } from "../modules/payment/pages";
import PostsPage from "../modules/posts/pages/index";
import { ProfileDashboard } from "../modules/profile-dashboard/pages";
import { ProfilesTracking } from "../modules/profiles-tracking/pages";
import { ReportsProfileSelection } from "../modules/reports/components/profile-selection";
import { Reports } from "../modules/reports/pages";
import { PerformanceReport } from "../modules/reports/pages/performance-report";
import ReviewsPage from "../modules/reviews/pages/index";
import { Sellers } from "../modules/sellers/pages";
import { PrivacyPolicyPage } from "../modules/terms/privacy";
import { TermsOfUsePage } from "../modules/terms/use-term";
import { BacklinksDashboardPage } from "../modules/backlinks-dashboard/pages";
import { DevLogin } from "../modules/login/pages/dev-login";

export const AppRoutes: React.FC = () => {
  return (
    <Router>
      <Routes>
        {/* Raiz: redireciona para /login */}
        <Route path="/" element={<Navigate to="/login" replace />} />

        <Route
          path="/auth/google/callback"
          element={<GoogleCallbackPageAdm />}
        />
        {/* Rotas Públicas */}
        <Route
          path="/auth/manager/google/callback"
          element={<GoogleCallbackEmailPage />}
        />
        <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
        <Route path="/terms-of-use" element={<TermsOfUsePage />} />
        <Route path="/payment-success" element={<PaymentSuccess />} />
        <Route path="/payment-error" element={<PaymentError />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/dashboard/:profileId" element={<Dashboard />} />
        <Route path="/profile-setup" element={<ProfileSetup />} />
        <Route path="/georanking" element={<GeoRanking />} />

        <Route path="/login" element={<PublicRoutes />}>
          <Route index element={<Login />} />
          <Route path="admin" element={<ActiveUserLogin />} />
          {import.meta.env.VITE_DEV && <Route path="dev" element={<DevLogin />} />}
        </Route>
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />

        <Route
          path="/reports/keywords"
          element={<ReportsProfileSelection reportType="keywords" />}
        />
        <Route path="/reports/keywords/:profileId" element={<Reports />} />
        <Route path="/reports/performance" element={<PerformanceReport />} />
        {/* Rotas Protegidas */}
        <Route element={<ProtectedClientRoutes />}>
          {/* Nova rota Home */}
          <Route path="/home" element={<Home />} />
          <Route path="/profiles-tracking" element={<ProfilesTracking />} />
          <Route path="/reviews" element={<ReviewsPage />} />
          <Route path="/posts" element={<PostsPage />} />
          <Route path="/backlinks-dashboard" element={<BacklinksDashboardPage />} />
          <Route path="/change-password" element={<ChangePassword />} />
          {/* Rotas com o layout de navegação */}
          <Route element={<NavTab />}>
            <Route path="/select-profile" element={<ProfileSelection />} />
          </Route>
        </Route>
        <Route element={<ProtectedAdminRoutes />}>
          <Route path="/admin" element={<ProfileDashboard />} />
          <Route path="/following-profiles" element={<FollowingProfiles />} />
          <Route path="/clients" element={<Clients />} />
          <Route path="/sellers" element={<Sellers />} />
          <Route path="/cases" element={<Cases />} />
          <Route path="/email" element={<EmailPage />} />
          <Route path="/payment" element={<Payment />} />
          <Route path="/backlinks-dashboard" element={<BacklinksDashboardPage />} />
          <Route path="/change-password" element={<ChangePassword />} />
        </Route>

        {/* Rota 404 - DEVE estar por último */}
        <Route
          path="*"
          element={<p style={{ padding: 24 }}>Página não encontrada</p>}
        />
      </Routes>
    </Router>
  );
};
